"use client"

import { useTranslation } from "react-i18next"

export const ContactSectionElement = ({
  contactInfo: _contactInfo,
}: {
  contactInfo: {
    address: string
    phone: string
    email: string
  }
}) => {
  const { t } = useTranslation()

  return (
    <div className="w-full flex flex-col gap-y-2">
      <span className="txt-small-plus txt-ui-fg-base">{t("footer.contact")}</span>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 justify-between gap-y-6 gap-x-8 text-ui-fg-subtle txt-small">
        <div>
          <p className="font-semibold text-ui-fg-base">
            {t("footer.taxOfficeNumber")}
          </p>
          <p>{"11111111"}</p>
        </div>
        <div>
          <p className="font-semibold text-ui-fg-base">{t("footer.company")}</p>
          <p>{"CyprusCodes Insaat"}</p>
        </div>
        <div>
          <p className="font-semibold text-ui-fg-base">{t("footer.address")}</p>
          <p>{"Lefkosa KKTC"}</p>
        </div>
        <div>
          <p className="font-semibold text-ui-fg-base">
            {t("footer.customerSupport")}
          </p>
          <p>
            <a
              href="mailto:info@101yapi.com"
              className="hover:text-ui-fg-base"
            >
              info@101yapi.com
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
